import { memo } from 'react';

/**
 * Carriers — "My Partners / Carriers I Represent" as a centered bulleted list
 * (the mockup's bulleted variant — carrier names are free text). Collapses
 * when no carriers are set.
 */
export const Carriers = memo(({ carriers = [] }) => {
  if (!carriers.length) return null;

  return (
    <section className="cw-section section-carriers" id="carriers">
      <div className="cw-container">
        <header className="section-head reveal">
          <p className="section-eyebrow">My Partners</p>
          <h2 className="section-title">Carriers I Represent</h2>
          <span className="section-bar" aria-hidden="true" />
        </header>
        <p className="carriers-intro reveal">
          I work with a variety of top-rated carriers so you always get the right options for your coverage needs and
          budget.
        </p>
        <ul className="carriers-list reveal">
          {carriers.map((carrier, i) => (
            <li key={`${carrier}-${i}`}>{carrier}</li>
          ))}
        </ul>
      </div>
    </section>
  );
});
